export const TWO_WAY_STAKE = 2; // двухисходка (2 бета в ставке)
export const THREE_WAY_STAKE = 3; // трехисходка (3 бета в ставке)

export type GRID_STAKE_LAYOUT = number;

/**
 * Items of array is a bet key(position) in stake.
 * With this array we can correct display bets in stake.
 **/
export const BET_KEYS_RENDERER_MAP = {
  [TWO_WAY_STAKE]: [1, 2],
  [THREE_WAY_STAKE]: [1, 2, 3],
};
